var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconKf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#718F83"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5387 21H14.9156L12.2262 17.1211L11.4 17.7949V21H9.99961V12.4336H11.4V16.5234C11.7828 16.0547 12.1637 15.6035 12.5426 15.1699L14.857 12.4336H16.4508C14.9547 14.1914 13.8824 15.4434 13.234 16.1895L16.5387 21ZM19.2641 21H17.8754V12.4336H22.7094V13.6172H19.2641V16.2949H22.4926V17.4844H19.2641V21Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKf);
export default __webpack_public_path__ + "static/media/icon-kf.685cba80482a1c075cd3ece026a00f5e.svg";
export { ForwardRef as ReactComponent };